const CourseTypes = {
    Group: 1,
    Individual: 2
} as const

export default CourseTypes;